import { Box, useDisclosure, useToast } from "@chakra-ui/react";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Title } from "../../components/Title";
import { ArticleForm, IArticleFormValues } from "../../forms";
import { ArticlesDocument, useCreateArticleMutation } from "../../graphql";

const CreateArticlePage: React.FC = () => {
  const toast = useToast();
  const history = useHistory();
  const [create] = useCreateArticleMutation();

  const onCreate = async (values: IArticleFormValues) => {
    const { data } = await create({
      variables: {
        coverMediaKey: values.cover.key,
        body: values.body,
        title: values.title,
        languageCode: values.languageCode,
        excerpt: values.excerpt,
      },
      refetchQueries: [{ query: ArticlesDocument }],
    });

    toast({
      description: "Artikulli u publikua.",
      status: "success",
      isClosable: true,
    });

    history.push(`/article/${data.createArticle.id}`);
  };

  return (
    <>
      <Box
        borderWidth="1px"
        borderRadius="lg"
        overflow="hidden"
        p={2}
        background="white"
      >
        <Title title="Shto artikull të ri"></Title>
        <ArticleForm onSubmit={onCreate} />
      </Box>
    </>
  );
};

export default CreateArticlePage;
